import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Popper from '@mui/material/Popper';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';

import RangeSlider from './RangeSlider';
import RangeSliderDisable from './RangeSliderDisable';
import { ArrowUpIn, ArrowUpOut, PopBox } from '../customStyles/box';
import { rangeFormat, rangeTxtDisable, rangeTxt, inputStyle } from './sliderStyle';
import theme from '../../theme';


const SliderIndex = (props) => {
  const {
    userQuery,
    setUserQuery,
    handleUserQuery,
  } = props;

  const [target, setTarget] = useState(null);
  const [rangeValue, setRangeValue] = useState([0, 100]);
  const [inputErrorMsg, setInputErrorMsg] = useState(false);
  const isOpen = Boolean(target);

  const handleMenuOpen = (e) => {
    setTarget(e.currentTarget);
  }

  const handleMenuClose = () => {
    const currnetValue = Array.from(userQuery);
    setRangeValue(currnetValue);
    setTarget(null);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const currnetValue = Array.from(rangeValue);
    const newValue = parseInt(value, 10);

    if (name === 'rangeValue-lowest') {
      currnetValue[0] = newValue;
      setRangeValue(currnetValue);

    } else if (name === 'rangeValue-highest') {
      currnetValue[1] = newValue;
      setRangeValue(currnetValue);
    }
  }

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const currnetValue = Array.from(rangeValue);

    if (name === 'rangeValue-lowest') {
      if (value < 0) {
        currnetValue[0] = 0;
        setRangeValue(currnetValue);
      } else if (value > 100) {
        currnetValue[0] = 100;
        setRangeValue(currnetValue);
      }

    } else if (name === 'rangeValue-highest') {
      if (value < 0) {
        currnetValue[1] = 0;
        setRangeValue(currnetValue);
      } else if (value > 100) {
        currnetValue[1] = 100;
        setRangeValue(currnetValue);
      }
    }
  };

  const handleRangeSubmit = (e) => {
    const currnetValue = Array.from(rangeValue);
    const isLowestNaN = typeof currnetValue[0] === 'number' && isNaN(currnetValue[0]);
    const isHighestNaN = typeof currnetValue[1] === 'number' && isNaN(currnetValue[1]);

    if (isLowestNaN || isHighestNaN) {
      setInputErrorMsg(true);
      return;
    } else {
      setInputErrorMsg(false);
    }

    if (currnetValue[0] > currnetValue[1]) {
      currnetValue.reverse();
      setRangeValue(currnetValue);
    }
    setTarget(null);
    handleUserQuery(currnetValue);
  }

  // console.log('rangeValue', rangeValue);

  return (
    <>
      <Button
        variant="text-system-normal"
        onClick={handleMenuOpen}
      >
        <Box sx={{ padding: '28px 0 0' }}>
          <RangeSliderDisable
            rangeTxt={rangeTxtDisable}
            rangeFormat={rangeFormat}
            rangeValue={userQuery}
            setRangeValue={setUserQuery}
          />
        </Box>
      </Button>

      <Popper
        open={isOpen}
        anchorEl={target}
        placement='bottom'
        style={{
          zIndex: 1000
        }}
      >
        <Stack variant="center-center">
          <Box sx={{ marginTop: '2px', }}>
            <Stack variant="center-center">
              <ArrowUpIn />
              <ArrowUpOut />
            </Stack>
            <PopBox>
              <Typography variant='h5' color={theme.palette.grey.w800}>用戶分級</Typography>

              <Divider sx={{ mt: 1.5, mb: 1 }} />

              <Stack variant="center-center" sx={{ p: '10px 20px' }}>
                <TextField
                  size="small"
                  name="rangeValue-lowest"
                  placeholder=""
                  value={rangeValue[0]}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>%</InputAdornment>,
                  }}
                  inputProps={{
                    step: 1,
                    min: 0,
                    max: 100,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  error={inputErrorMsg}
                  sx={inputStyle}
                />

                <Typography>　～　</Typography>

                <TextField
                  size="small"
                  name="rangeValue-highest"
                  placeholder=""
                  value={rangeValue[1]}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>%</InputAdornment>,
                  }}
                  inputProps={{
                    step: 1,
                    min: 0,
                    max: 100,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  error={inputErrorMsg}
                  sx={inputStyle}
                />
              </Stack>

              <Box sx={{ p: '24px 20px' }}>
                <RangeSlider
                  rangeTxt={rangeTxt}
                  rangeFormat={rangeFormat}
                  rangeValue={rangeValue}
                  setRangeValue={setRangeValue}
                />
              </Box>

              <Stack variant="between-center" sx={{ p: '10px 20px' }}>
                <FormHelperText error>{inputErrorMsg ? "請輸入百分比" : ''}</FormHelperText>

                <Stack variant="end-center">
                  <Button
                    variant="text-cancel"
                    onClick={handleMenuClose}
                  >
                    取消
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleRangeSubmit}
                  >
                    套用
                  </Button>
                </Stack>

              </Stack>

            </PopBox>
          </Box>
        </Stack>
      </Popper>
    </>
  );
}

export default SliderIndex;